<div id="vouchersBase">
    <app-header [headerTitle]="'home.vouchers.0' | translate" [navBack]="'true'" [accessActions]="false"></app-header>

    <div class="baseContainer">
        <div class="tabs">
            <a [title]="'home.catalogue' | translate" class="select">{{ 'home.catalogue' | translate }}</a>
            <a routerLink="/wallet/vouchers" [title]="'side-nav.myVouchers.0' | translate">{{ 'side-nav.myVouchers.0' | translate }}</a>
        </div>
        
        <main class="voucherBox">

            <a *ngFor="let voucher of Contents" (click)="!sliding && navigate(['voucher', voucher.id])" [hidden]="voucher.type == 'SLIDER'" class="voucher">
                <img [src]="voucher.image_url" [alt]="voucher.name">
                <span [class.hided]="!voucher.discountLabel" [innerHTML]="voucher.discountLabel || '-'"></span>
                <b>{{ voucher.name }}</b>
                <p [innerHTML]="voucher.priceLabel"></p>
            </a>
            
            <button *ngIf="!loading_ && (!!Contents?.length && totalVoucher > Contents.length)" class="btn mb-3" (click)="loadContents(true)">{{ 'global.loadMore' | translate }}</button>
             
            <div *ngIf="!Contents || loading_" class="contentLoader my-5 py-5"><span></span></div>
                
            <h5 *ngIf="!!Contents && !Contents.length" class="text-center py-5 my-5">{{ 'home.noVoucherFound' | translate }}</h5>
        </main>

    </div>

    <!-- <a routerLink="/search" class="floatSearch"><i class="fas fa-search"></i></a> -->

</div>